import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/reports";

export const ListRevenuereport = async (values) => {
  return await axiosInstance(options).post(`${path}/list-revenue-report`, values);
};

export const ListRedemptionreport = async (values) => {
  return await axiosInstance(options).post(`${path}/list-redemption-report`, values);
};

export const DetailsRevenuereport = async (values) => {
  return await axiosInstance(options).get(`${path}/details-revenue-report?_id=${values}`);
};

export const DetailsRedemptionreport = async (values) => {
  return await axiosInstance(options).get(`${path}/detail-redemption-report?id=${values}`);
};